import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  error: "",
  list: [],
};

const UserListSlice = createSlice({
  name: "UserList",
  initialState,
  reducers: {
    userListSuccess(state, action) {
      state.list = action.payload
    },
    userListError(state, action) {
        state.error = action.payload
    },
  },
});

export const {
  userListSuccess,
  userListError,
} = UserListSlice.actions

export default UserListSlice.reducer;
